import { PlatformLinkingProvider, PlatformType } from '@okletsplay/core';
import { DialogName } from 'app/enums';
import { modalsReducers } from 'app/store/modal/slice';
import { sessionSelector } from 'app/store/session/selectors';
import { useMatchModal } from 'modules/matches/hooks';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const usePlatformLinkAction = (platform?: PlatformType) => {
  const connections = useSelector(sessionSelector.connections);
  const lolPlatformLinkingProvider = useSelector(sessionSelector.lolPlatformLinkingProvider);
  const dispatch = useDispatch();

  const { closeMatchModal } = useMatchModal();

  const isLinked = useCallback(
    (provider: PlatformLinkingProvider) =>
      Boolean(connections.find((connection) => connection.platformId === provider)),
    [connections]
  );

  const isPlatformLinked = useMemo(() => {
    switch (platform) {
      case PlatformType.Lichess:
        return isLinked(PlatformLinkingProvider.Lichess);
      case PlatformType.Lidraughts:
        return isLinked(PlatformLinkingProvider.Lidraughts);
      case PlatformType.EvIo:
        return isLinked(PlatformLinkingProvider.EvIo);
      case PlatformType.LeagueOfLegends:
        return Boolean(lolPlatformLinkingProvider);
      case PlatformType.Olp:
      case PlatformType.Steam:
      default:
        return true;
    }
  }, [isLinked, lolPlatformLinkingProvider, platform]);

  const openPlatformLink = useCallback(() => {
    if (isPlatformLinked) {
      return;
    }

    closeMatchModal();
    dispatch(modalsReducers.closeAllModals());
    dispatch(modalsReducers.openModal({ name: DialogName.PlatformLink, data: platform }));
  }, [closeMatchModal, dispatch, isPlatformLinked, platform]);

  return { openPlatformLink, isPlatformLinked };
};
